export const isAdmin = (user: any) => {
  const userGroups = user?.getSignInUserSession
    ? user?.getSignInUserSession()?.getIdToken().payload['cognito:groups']
    : user?.idToken?.payload['cognito:groups'];
  return userGroups && userGroups.includes('UK_LAB_SHIPMENT_ADMIN');
};
